import { generateUrlFromFilterOptions } from 'src/account/components/SearchAlerts/SearchAlerts.helpers';
import { RecentFilterSearch } from 'src/hygiene/components/flexible-content/RecentSearch/RecentSearch.type';
import { FilterOption } from 'src/plp/components/PlpFilters/PlpFilters.type';
import { FilterValues } from 'src/types/CataloguePage.types';

const MAX_RECENT_FILTERS = 3;

export const removeFilterFromFilters = (filters: RecentFilterSearch[], filter: RecentFilterSearch) => {
  return filters.filter((item) => item.id !== filter.id);
};

const formatRecentSearchFilter = (filters: FilterOption[]): RecentFilterSearch | null => {
  if (Object.keys(filters).length === 0) {
    return null;
  }

  const url = generateUrlFromFilterOptions(filters);

  // Don't store the recent search if the search params have been filtered out
  if (url === '/used-cars') {
    return null;
  }

  const result: RecentFilterSearch = {
    id: url,
    url,
    filters: filters,
  };

  return result;
};

export const addRecentSearchFilter = (
  filters: FilterOption[],
  recentSearches: RecentFilterSearch[],
): { updated: boolean; recentSearches: RecentFilterSearch[] | null } => {
  let updated: boolean = false;
  let newRecentSearches = [...recentSearches];
  const newRecentSearch = formatRecentSearchFilter(filters);
  if (!newRecentSearch || filters.find((item) => item.filter === FilterValues.Keyword)) {
    return { updated: false, recentSearches };
  }

  if (newRecentSearches.length > 0) {
    updated = newRecentSearches[0].id !== newRecentSearch.id;
  } else {
    updated = true;
  }

  if (updated) {
    newRecentSearches = removeFilterFromFilters(newRecentSearches, newRecentSearch);
    newRecentSearches.unshift(newRecentSearch);
  }

  return {
    updated,
    recentSearches: newRecentSearches.slice(0, MAX_RECENT_FILTERS),
  };
};
